import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import { MandantService } from '../../api';

export const getMandantenByHauptmandant =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    new MandantService().getMandantSumarriesByHauptmandant().then(response => {
      dispatch({
        type: ActionTypes.GET_MANDANTEN_BY_HAUPTMANDANT,
        payload: response.data,
      });
    });
  };
